module.exports = __webpack_public_path__ + "static/media/dining-room.0867fac1.svg";